//
// Site JS
//

// Vendors
import Splide from './vendor/splide/splide.min.js';

// Modules
import MenuToggle from './components/menu-toggle';

// Check if JS is enabled in browser, if so the `no-js` class is removed from <body>
document.body.classList.remove('no-js');

// Once page is loaded
document.addEventListener('DOMContentLoaded', function () {

    // Remove .preload class
    document.body.classList.remove('preload');

    // Set autoplay attributes to videos only if motion-preference allows
    let motionPreferenceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    // Search for videos set to autoplay and remove related attributes
    function removeAttributes() {
        let videosPresent = document.getElementsByClassName('video--background');

        for (const video of videosPresent) {
            video.removeAttribute('autoplay');
            video.removeAttribute('disablepictureinpicture', '');
            video.removeAttribute('loop', '');
            video.removeAttribute('muted', '');
            video.removeAttribute('playsinline', '');
        } 
    }

    // Check for motion preference, remove autoplay attributes if desired
    if (motionPreferenceQuery.matches) {
        removeAttributes();
    }

    // Showreel video play
    const showreelVideo = document.querySelector('#js-showreel-video');
    const showreelPlayInFullToggle = document.querySelector('#js-showreel-toggle');

    // Check for showreel audio toggle button on page
    if(document.body.contains(showreelPlayInFullToggle)) {
        // Assign event listener to unmute video when clicked
        showreelPlayInFullToggle.addEventListener("click", function() {
            // Un-mute the video
            showreelVideo.muted = !showreelVideo.muted;
            // Disable loop
            showreelVideo.loop = !showreelVideo.loop;
            // Enable controls
            showreelVideo.controls = !showreelVideo.controls;
            // Hide the PlayInFullToggle button
            showreelPlayInFullToggle.classList.add("showreel__toggle--hidden");
            // Play the video
            showreelVideo.play();
        });
    }

    // Splide (used for galleries)

    // Set defaults for all galleries
    Splide.defaults = {
        type: 'loop',
        perPage: 1,
        gap: '22px',
        padding: { left: '20%', right: '20%' },
    }

    // Initialise Slide for all .splide elements
    var elms = document.getElementsByClassName( 'splide' );
    for ( var i = 0; i < elms.length; i++ ) {
        new Splide( elms[ i ] ).mount();
    }

}, false);
